import { useMemo } from 'react'
import { RiskStatus, RiskStatusReadableString } from '../types/resourceExplorer'

const riskStatusMap: Record<RiskStatus, RiskStatusReadableString | string> = {
  [RiskStatus.Extreme]: RiskStatusReadableString.ExtremeRisk,
  [RiskStatus.High]: RiskStatusReadableString.HighRisk,
  [RiskStatus.Medium]: RiskStatusReadableString.MediumRisk,
  [RiskStatus.Low]: RiskStatusReadableString.LowRisk,
  [RiskStatus.NotApplicable]: 'Not applicable',
  [RiskStatus.Pending]: 'Pending',
  [RiskStatus.Deactivated]: 'Not activated',
  [RiskStatus.InsufficientData]: 'Insufficient data',
}

export const useRiskStatus = () => {
  const riskStatuses: RiskStatus[] = useMemo(
    () => [RiskStatus.Extreme, RiskStatus.High, RiskStatus.Medium, RiskStatus.Low],
    [],
  )

  const riskStatusOptions = useMemo(
    () =>
      riskStatuses.map(status => ({
        label: riskStatusMap[status],
        value: status,
      })),
    [riskStatuses],
  )

  return {
    riskStatuses,
    riskStatusOptions,
  }
}
